/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_filter`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//Leave list
export async function loadObsDetails(searchFilter,) {
console.log(searchFilter,"myremote")

  if (searchFilter) {
    return await api
      .post(`/get_all_obs_import_details`, searchFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } 
  else{
    return await api
    .post(`/get_all_obs_import_details`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
 export function updateLeaveDetails(leaveDetails) {

  return api
    .post(`/editLeave`, leaveDetails)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
 export function updateLpndDetails(statusDetails) {
  return api
    .put(`/update_lpnd_request`, statusDetails)
    .catch((error) => Promise.reject(error))
}

 //delete 

 export function deleteLeaveRequest(leaveData) {
  return api
    .post(`/deleteLeave`,leaveData)
    .catch((error) => Promise.reject(error))
}

export function applyLeaveDetailsList(applyLeaveDetails) {
  return api
    .post(`/applyLeave`, applyLeaveDetails)
    .catch((error) => Promise.reject(error))
}

export function updateObsDetails(obsDetails) {

  return api
    .put(`/update_obs_import_details`, obsDetails)
    .catch((error) => Promise.reject(error))
}



 //delete 

 export function deleteObsDetails(deleteData) {
  return api
    .put(`/delete_obs_import_details`,deleteData)
    .catch((error) => Promise.reject(error))
}

// add followup 
export async function  addFollowUpRemote(submitFollowUp) {
  return await api
    .post(`/add_obsFollowUpData`,submitFollowUp)
    .catch((error) => Promise.reject(error))
}
//load followup
export function loadFollowUpDetails(obsImportId) {
 
  return api
    .post(`/get_obs_Fllowup_history`, obsImportId)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadRecordsMetaData,
  loadEmployeeList,
  loadObsDetails,
  updateLeaveDetails,
  updateLpndDetails,
  deleteLeaveRequest,
  applyLeaveDetailsList,
  addFollowUpRemote,

  updateObsDetails,
  deleteObsDetails,
}

export default remotes
